import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Images, useModal } from 'utils';
import { CustomDelete, CustomizedSwitch, SimpleTooltip } from 'components';
import { systemActions } from 'store';
import { systemItemStyles } from './styles';
import { ConnectGoogleMeet } from './modals';

const DISCONNECT_GOOGLE_MEET = 'EDIT_GOOGLE_MEET_STATUS';
export const GoogleMeet = () => {
    const googleMeetConnection = useSelector((state) => state.system.googleMeetConnection);
    const zoomConnection = useSelector((state) => state.system.zoomConnection);
    const classes = systemItemStyles();
    const dispatch = useDispatch();
    const { open } = useModal();
    const [connect, setConnect] = useState(false);
    const otherProviderConnected = zoomConnection?.isConnected;

    useEffect(() => {
        if (googleMeetConnection) {
            setConnect(googleMeetConnection?.isConnected);
        }
    }, [googleMeetConnection]);

    const handleConnect = () => {
        open(<ConnectGoogleMeet />);
    };

    return (
        <div>
            <div className="office-ally-box">
                <div className="space-between" style={{ padding: 16 }}>
                    <div className={classes.iconAndTitle}>
                        <img src={Images.googleMeet} alt="googleMeet" />
                        <p>Google Meet</p>
                    </div>
                    {googleMeetConnection?.isConnected ? (
                        <div className={classes.iconAndTitle} style={{ gap: 16, height: 32 }}>
                            <SimpleTooltip title="Disconnect Google Meet" placement="top-start">
                                <CustomizedSwitch
                                    checked={connect}
                                    handleClick={() => {
                                        open(
                                            <CustomDelete
                                                text="Are you sure you want to disconnect Google Meet? This action is not reversible."
                                                info="Disconnect Google Meet"
                                                handleDel={() => dispatch(systemActions.editGoogleMeetStatus())}
                                                actionType={DISCONNECT_GOOGLE_MEET}
                                                innerText={'Disconnect'}
                                                color={'blue'}
                                            />,
                                        );
                                    }}
                                />
                            </SimpleTooltip>
                        </div>
                    ) : otherProviderConnected ? (
                        <SimpleTooltip title="Disconnect Zoom first" placement="top-start">
                            <span>
                                <button disabled className={classes.connectBtn} style={{ opacity: 0.5 }}>
                                    Connect
                                </button>
                            </span>
                        </SimpleTooltip>
                    ) : (
                        <button onClick={handleConnect} className={classes.connectBtn}>
                            Connect
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};
